<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="68px">
      <el-form-item prop="countryNameEn">
        <el-input v-model="queryParams.countryNameEn" placeholder="国家或地区（英文）" clearable style="width: 200px" @keyup.enter.native="search" />
      </el-form-item>
      <el-form-item prop="countryName">
        <el-input v-model="queryParams.countryName" placeholder="国家或地区（简体）" clearable style="width: 200px" @keyup.enter.native="search" />
      </el-form-item>
      <el-form-item prop="operator">
        <el-input v-model="queryParams.operator" placeholder="当地运营商" clearable style="width: 180px" @keyup.enter.native="search" />
      </el-form-item>
      <el-form-item prop="network">
        <el-select v-model="queryParams.network" placeholder="网络类型" clearable style="width: 150px">
          <el-option v-for="item in networkOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item prop="apn">
        <el-input v-model="queryParams.apn" placeholder="APN" clearable style="width: 150px" @keyup.enter.native="search" />
      </el-form-item>
      <el-form-item prop="cardType">
        <el-input v-model="queryParams.cardType" autocomplete="off" style="width: 130px" placeholder="请输入卡类型"></el-input>
      </el-form-item>
      <el-form-item prop="sms">
        <el-select v-model="queryParams.sms" placeholder="短信功能" clearable style="width: 130px">
          <el-option v-for="item in smsOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item prop="remark">
        <el-input v-model="queryParams.remark" placeholder="备注" clearable style="width: 150px" @keyup.enter.native="search" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd" v-hasPermi="['international:network:save']">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="loading" :data="tableData" border
      :row-class-name="tableRowClassName"
      @cell-click="cellClick">
        <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" class="table-expand">
            <el-row>
              <el-col :span="12">
                <el-row>
                  <el-col :span="6">
                    <el-form-item label="创建人" >
                      <span>{{ props.row.createUser }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="创建时间" >
                      <span>{{ props.row.createTime }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
      <el-table-column prop="countryNameEn" label="国家或地区（英文）" align="center" min-width="150" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="countryName" label="国家或地区（简体）" align="center" min-width="130" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="operator" label="当地运营商" align="center" min-width="200" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="network" label="网络类型" align="center" min-width="100" :show-overflow-tooltip="true">
        <template slot-scope="{row}">
          <el-tag v-if="!!row.network" type="info">{{ row.network }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="apn" label="APN" align="center" min-width="160" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="cardType" label="卡类型" align="center" min-width="90" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="sms" label="短信功能" align="center" min-width="80">
        <template slot-scope="{row}">
          <el-tag v-if="row.sms === '无' || !row.sms" type="info">无</el-tag>
          <el-tag v-else-if="row.sms === 'MO'" type="success">MO</el-tag>
          <el-tag v-else-if="row.sms === 'MT'" type="warning">MT</el-tag>
          <el-tag v-else-if="row.sms === 'MO/MT'" type="danger">MO/MT</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center" min-width="80">
        <template slot-scope="{row}">
          <el-switch
            v-model="row.status"
            active-color="#13ce66"
            active-value="1"
            inactive-value="0"
            @change="changeStatus(row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" align="center" min-width="150" :show-overflow-tooltip="false">
        <template slot-scope="scope">
          <el-input v-if="scope.row.index === tabClickIndex" v-model="scope.row.remark" v-focus
                    size="small" type="text" @blur="inputBlur(scope.row)"
                    placeholder="请输入备注"/>
          <div v-else style="cursor: pointer; min-height: 32px; line-height: 32px;">
            <span>{{ scope.row.remark }}</span>
            <i style="margin-left: 5px" class="el-icon-edit"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width" fixed="right" width="80">
        <template v-slot:default="{row}">
          <el-button size="mini" type="text" icon="el-icon-edit" @click="handleEdit(row)" v-hasPermi="['international:network:update']">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="title" :visible.sync="dialog" :lock-scroll="false" width="750px" v-dialogDrag :close-on-click-modal="false" @close="dialogClose">
      <el-form :model="form" ref="form" :rules="rules" label-width="200px">
        <el-form-item label="国家或地区（英文）:" prop="countryNameEn">
          <el-input v-model="form.countryNameEn" autocomplete="off" style="width: 90%" placeholder="请输入国家或地区英文名称"></el-input>
        </el-form-item>
        <el-form-item label="国家或地区（简体）:" prop="countryName">
          <el-input v-model="form.countryName" autocomplete="off" style="width: 90%" placeholder="请输入国家或地区简体名称"></el-input>
        </el-form-item>
        <el-form-item label="当地运营商:" prop="operator">
          <el-input v-model="form.operator" autocomplete="off" style="width: 90%" placeholder="请输入当地运营商"></el-input>
        </el-form-item>
        <el-form-item label="网络类型:" prop="network">
          <el-select v-model="form.network" clearable placeholder="请选择网络类型" style="width: 90%">
            <el-option v-for="item in networkOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="APN:" prop="apn">
          <el-input v-model="form.apn" autocomplete="off" style="width: 90%" placeholder="请输入APN"></el-input>
        </el-form-item>
        <el-form-item label="卡类型:" prop="cardType">
          <el-input v-model="form.cardType" autocomplete="off" style="width: 90%" placeholder="请输入卡类型"></el-input>
        </el-form-item>
        <el-form-item label="短信功能:" prop="sms">
          <el-select v-model="form.sms" clearable placeholder="请选择短信功能" style="width: 90%">
            <el-option v-for="item in smsOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态:" prop="status">
          <el-switch
            v-model="form.status"
            active-color="#13ce66"
            active-value="1"
            inactive-value="0"
            active-text="打开"
            inactive-text="关闭">
          </el-switch>
        </el-form-item>
        <el-form-item label="备注:" prop="remark">
          <el-input type="textarea" v-model="form.remark" autocomplete="off" style="width: 90%" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button type="primary" @click="cancel">取消</el-button>
        <el-button type="success" @click="submit">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  internationalNetworkPage,
  internationalNetworkSave,
  internationalNetworkUpdate,
  internationalNetworkChangeStatus
} from "@/api/international.js";

export default {
  name: "InternationalNetworkList",
  directives: {
    focus: {
      inserted(el) {
        el.querySelector('input').focus()
      }
    }
  },
  data() {
    return {
      // 行内编辑标记
      tabClickIndex: null,
      // 查询条件
      queryParams: {
        countryNameEn: undefined,
        countryName: undefined,
        operator: undefined,
        network: undefined,
        apn: undefined,
        cardType: undefined,
        sms: undefined,
        remark: undefined
      },
      // 遮罩层
      loading: true,
      // 分页器
      page: 1,
      pageSize: 20,
      total: 0,
      // 列表数据
      tableData: [],
      // 弹窗
      title: "",
      dialog: false,
      // 表单
      form: {
        id: undefined,
        countryNameEn: undefined,
        countryName: undefined,
        operator: undefined,
        network: undefined,
        apn: undefined,
        cardType: undefined,
        sms: "无",
        status: "1",
        remark: undefined
      },
      // 表单校验
      rules: {
        countryNameEn: [
          { required: true, message: "请输入国家或地区英文名称", trigger: "blur" }
        ],
        countryName: [
          { required: true, message: "请输入国家或地区简体名称", trigger: "blur" }
        ],
        operator: [
          { required: true, message: "请输入当地运营商", trigger: "blur" }
        ],
        network: [
          { required: true, message: "请选择网络类型", trigger: "change" }
        ],
        apn: [
          { required: true, message: "请输入APN", trigger: "blur" }
        ],
        cardType: [
          { required: true, message: "请选择卡类型", trigger: "change" }
        ]
      },
      // 网络类型选项
      networkOptions: [
        { value: "2G", label: "2G" },
        { value: "3G", label: "3G" },
        { value: "4G", label: "4G" },
        { value: "5G", label: "5G" },
        { value: "GPRS", label: "GPRS" },
        { value: "2G/3G", label: "2G/3G" },
        { value: "3G/4G", label: "3G/4G" },
        { value: "4G/5G", label: "4G/5G" },
        { value: "2G/3G/4G", label: "2G/3G/4G" },
        { value: "3G/4G/5G", label: "3G/4G/5G" },
        { value: "2G/3G/4G/5G", label: "2G/3G/4G/5G" },
      ],
      // 短信功能选项
      smsOptions: [
        { value: "无", label: "无" },
        { value: "MO", label: "MO" },
        { value: "MT", label: "MT" },
        { value: "MO/MT", label: "MO/MT" }
      ]
    };
  },
  methods: {
    // 新增
    handleAdd() {
      this.title = "新增国际网络信息";
      this.form = {
        id: undefined,
        countryNameEn: undefined,
        countryName: undefined,
        operator: undefined,
        network: undefined,
        apn: undefined,
        cardType: undefined,
        sms: "无",
        status: "1",
        remark: undefined
      };
      this.dialog = true;
    },
    // 编辑
    handleEdit(row) {
      this.title = "编辑国际网络信息";
      this.form = Object.assign({}, row);
      this.dialog = true;
    },
    // 弹窗关闭
    dialogClose() {
      this.$refs.form && this.$refs.form.clearValidate();
    },
    // 取消
    cancel() {
      this.dialog = false;
    },
    // 提交
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (!!this.form.id) {
            internationalNetworkUpdate(this.form).then(res => {
              if (res.data.code == 200) {
                this.$notify({
                  title: "成功",
                  message: "修改成功",
                  type: "success",
                  duration: 2000
                });
                this.cancel();
                this.initData();
              }
            });
          } else {
            internationalNetworkSave(this.form).then(res => {
              if (res.data.code == 200) {
                this.$notify({
                  title: "成功",
                  message: "新增成功",
                  type: "success",
                  duration: 2000
                });
                this.cancel();
                this.initData();
              }
            });
          }
        }
      });
    },
    // 修改状态
    changeStatus(row) {
      const newStatus = row.status;
      let params = {
        id: row.id,
        status: newStatus
      };
      internationalNetworkChangeStatus(params).then(res => {
        this.$notify({
          title: "成功",
          message: newStatus === "1" ? "已打开" : "已关闭",
          type: "success",
          duration: 2000
        });
      }).catch(() => {
        row.status = newStatus === "1" ? "0" : "1";
      });
    },
    // 行索引赋值
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex
    },
    // 单元格点击
    cellClick(row, column) {
      if (column.property === 'remark') {
        this.tabClickIndex = row.index
      } else {
        this.tabClickIndex = null
      }
    },
    // 备注失焦保存
    inputBlur(row) {
      this.tabClickIndex = null;
      let params = { id: row.id, remark: row.remark };
      internationalNetworkUpdate(params).then(res => {
        if (res.data.code == 200) {
          this.$notify({
            title: "成功",
            message: "备注修改成功",
            type: "success",
            duration: 2000
          });
        }
      });
    },
    // 获取列表
    initData() {
      this.loading = true;
      let params = {
        model: {
          ...this.queryParams
        },
        page: this.page,
        pageSize: this.pageSize
      };
      internationalNetworkPage(params).then(res => {
        this.loading = false;
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
      });
    },
    // 搜索
    search() {
      this.page = 1;
      this.initData();
    },
    // 重置
    resetQuery() {
      this.resetForm("queryForm");
      this.search();
    }
  },
  created() {
    this.initData();
  }
};
</script>
<style scoped lang="less">
.table-expand{
    margin-left: 20px;
    label{
      width: 90px;
      color: #99a9bf; 
    }
    .el-form-item{
      margin-bottom: 0;
    }
}
.el-button {
  margin-left: 5px;
  border-radius: 3px;
  padding: 10px 20px;
}
</style>
